export enum PendencyStatusNames {
  CREATED = 'Pendência aberta',
  RESOLVED = 'Pendência resolvida',
}
